import { z } from 'zod'

export const phoneNumber = z.object({
    id: z.string(),
    whatsappBusinessAccountId: z.string(),
    metaPhoneNumberId: z.string(),
    name: z.string(),
    number: z.string(),
    qualityRating: z.string(),
    lastSyncedAt: z.coerce.date().nullable().optional(),
    createdAt: z.coerce.date().nullable().optional(),
    updatedAt: z.coerce.date().nullable().optional(),
})

export type PhoneNumber = z.infer<typeof phoneNumber>
